<template>
    <div class="pop-over">
        <div>
            <div class="description">
                {{ $t('incomplete') }}
            </div>

            <div class="navigation-buttons" @click="close">
                <button class="btn btn-outline-dark next" type="submit">
                    {{ $t('back_answering') }}
                </button>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'ResultsPopup',
    data() {
        return {
        };
    },
    methods: {
        close() {
            this.$emit("close");
        },

    },
    mounted() {

    }
};
</script>

<style scoped>
.pop-over {
    background-color: #ffff;
    position: fixed;
    margin: auto;
    width: 500px;
    height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
    border-radius: 15px;

}

.btn {
    width: 150px;
}


.description {
    padding: 2rem;
    font-size: 1.2rem;
}
</style>